import { Link } from 'react-router-dom';

export default function MainButtons() {
  const buttons = [
    {
      icon: 'ri-lock-line',
      title: 'ロッキングリワード',
      gradient: 'from-pink-400 to-pink-600',
      link: '#',
    },
    {
      icon: 'ri-flashlight-line',
      title: 'アクティベーションリワード',
      gradient: 'from-purple-400 to-purple-600',
      link: null,
    },
    {
      icon: 'ri-shield-check-line',
      title: 'セキュリティガイド',
      gradient: 'from-pink-500 to-purple-500',
      link: '#',
    },
  ];

  return (
    <section className="py-24 px-6 bg-gradient-to-b from-white to-pink-50/30">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {buttons.map((button, index) => (
            <Link
              key={index}
              to={button.link || '#'}
              onClick={e => { if (!button.link || button.link === '#' || button.link === null) e.preventDefault(); }}
              className="group relative bg-white rounded-3xl p-10 shadow-lg hover:shadow-2xl transition-all duration-300 hover:scale-105 text-left border border-gray-100 block cursor-pointer"
            >
              <div className={`w-20 h-20 rounded-2xl bg-gradient-to-br ${button.gradient} flex items-center justify-center mb-6 group-hover:scale-110 transition-transform`}>
                <i className={`${button.icon} text-4xl text-white`}></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4 leading-tight">
                {button.title}
              </h3>
              <div className="mt-6 flex items-center text-pink-500 font-semibold text-lg">
                詳しく見る
                <i className="ri-arrow-right-line ml-2 group-hover:translate-x-2 transition-transform"></i>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
